import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBT-hR7YK05KTcQ_1VHiqv6rLufUCrWzsw',
  authDomain: 'pezeshkbook-6e828.firebaseapp.com',
  projectId: 'pezeshkbook-6e828',
  storageBucket: 'pezeshkbook-6e828.appspot.com',
  messagingSenderId: '667230373280',
  appId: '1:667230373280:web:b0e43b05a56572b219d0c5',
  measurementId: 'G-61J5ZB1ZKZ',
};

const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp;
